var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcThreeDotVertical333(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.00313C13.1226 7.00313 14 6.12188 14 4.99688C14 3.89063 13.1038 3 12 3C10.9057 3 10 3.89062 10 4.99687C10 6.09375 10.9057 7.00313 12 7.00313ZM12 13.9781C13.1226 13.9781 14 13.1063 14 12C14 10.9031 13.1038 10.0125 12 10.0125C10.9057 10.0125 10 10.9031 10 12C10 13.0875 10.9057 13.9781 12 13.9781ZM12 21C13.1226 21 14 20.1188 14 19.0031C14 17.8875 13.1038 16.9969 12 16.9969C10.9057 16.9969 10 17.8875 10 19.0031C10 20.0906 10.9057 21 12 21Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThreeDotVertical333);
export default __webpack_public_path__ + "static/media/icThreeDotVertical333.2eacfb0da37e4158fbc500ce704b855c.svg";
export { ForwardRef as ReactComponent };